import {
	BranchedQuestionOutputSchema,
	type BranchedQuestionInput
} from "src/features/Admin/models";
import { useMutation } from "@tanstack/react-query";
import { camelizeKeys, decamelizeKeys } from "humps";
import { cmsClient } from "src/services/cmsClient";

const createBranchedQuestion = async (
	branchedQuestion: BranchedQuestionInput
) => {
	const url = "/observations/admin/branched-questions/";
	const body = decamelizeKeys(branchedQuestion);

	const response = await cmsClient.post(url, body);
	const data = camelizeKeys(response.data);

	return BranchedQuestionOutputSchema.parse(data);
};

const useCreateBranchedQuestion = (observationFormId: number) => {
	const mutation = useMutation({
		mutationFn: createBranchedQuestion
	});

	return mutation;
};

export default useCreateBranchedQuestion;
